/*
 * Shared wishlist store. Saved items live in localStorage as
 * [{ id, handle }] — the id is matched against (stable across renames) and
 * the handle is what product URLs are built from.
 */
window.Wishlist = (function () {
  const STORAGE_KEY = 'vlj_wishlist';
  const EVENT = 'wishlist-update';

  function read() {
    let raw;
    try {
      raw = JSON.parse(localStorage.getItem(STORAGE_KEY));
    } catch (error) {
      return [];
    }
    if (!Array.isArray(raw)) return [];

    return raw
      .filter((item) => item && typeof item === 'object' && item.id != null && item.handle)
      .map((item) => ({ id: String(item.id), handle: String(item.handle) }));
  }

  function write(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      // Storage full or blocked — keep the in-page state consistent anyway.
    }
    publish(EVENT, { items });
  }

  function has(id) {
    return read().some((item) => item.id === String(id));
  }

  function add(product) {
    if (has(product.id)) return;
    write([...read(), { id: String(product.id), handle: product.handle }]);
  }

  function remove(id) {
    write(read().filter((item) => item.id !== String(id)));
  }

  function toggle(product) {
    const wishlisted = has(product.id);
    if (wishlisted) {
      remove(product.id);
    } else {
      add(product);
    }
    return !wishlisted;
  }

  // Keep other tabs in sync.
  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) publish(EVENT, { items: read() });
  });

  return { EVENT, read, write, has, add, remove, toggle, count: () => read().length };
})();
